import { useState } from "react";
import LoginDashBoard from "./LoginDashBoard";
import { Form, Input, Modal, message } from "antd";
import OTPInput from "../common/OTPInput";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { BASEURL } from "../../config";

export default function ForgotPassword() {
  const [otpMedium, setOtpMedium] = useState<string>("email");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isResetFormOpen, setIsResetFormOpen] = useState(false);
  const [email, setEmail] = useState<string>("");
  const [otp, setOtp] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [resetForm] = Form.useForm();
  const navigate = useNavigate();

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOtpMedium = (medium: string) => {
    setOtpMedium(medium);
  };

  const requestOtp = async (values: { email: string }) => {
    try {
      setLoading(true);
      setEmail(values.email);
      
      const response = await axios.post(`${BASEURL}auth/request-otp`, {
        email: values.email
      });      
      
      if (response.data.status) {
        message.success(response.data.message);
        showModal();
      } else {
        message.error('Failed to send OTP');
      }
    } catch (error:any) {
      message.error(error?.response?.data?.message || 'Error sending OTP');
      console.error(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOtp = async () => {
    if (otp.length !== 6) {
      message.error('Please enter complete OTP');
      return;
    }

    try {
      setLoading(true);
      const response = await axios.post(`${BASEURL}auth/verify-otp`, {
        email: email,
        otp: otp
      });
      
      message.success(response.data.message);
      setIsModalOpen(false);
      setIsResetFormOpen(true);
    } catch (error:any) {
      message.error(error?.response?.data?.message || 'Invalid OTP');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleResetPassword = async (values: { password: string, confirmPassword: string }) => {
    try {
      setLoading(true);
      const response = await axios.post(`${BASEURL}auth/reset-password`, {
        email: email,
        password: values.password,
        confirmPassword: values.confirmPassword
      });
      
      message.success('Password reset successfully');
      navigate('/login');
    } catch (error:any) {
      message.error(error?.response?.data?.message||'Failed to reset password');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onFinishFailed = (errorInfo: object) => {
    console.error('Form validation failed:', errorInfo);
  };

  return (
    <LoginDashBoard>
      <div className="flex justify-center w-full">
        {/* <div className="flex justify-center gap-2">
          <span
            className={`${
              otpMedium === "email"
                ? "text-yellow underline font-extrabold"
                : "text-black font-normal"
            } text-lg cursor-pointer`}
            onClick={() => {
              handleOtpMedium("email");
            }}
          >
            {otpMedium === "email"
              ? "Email address".toUpperCase()
              : "Email address"}
          </span>
          <span>/</span>
          <span
            className={` ${
              otpMedium === "phone"
                ? "text-yellow underline font-extrabold"
                : "text-black font-normal"
            } text-lg cursor-pointer`}
            onClick={() => {
              handleOtpMedium("phone");
            }}
          >
            {otpMedium === "phone"
              ? "Phone number".toUpperCase()
              : "Phone number"}
          </span>
        </div> */}
      </div>
      
      {!isResetFormOpen ? (
        <Form
          name="forgotPassword"
          initialValues={{ remember: true }}
          onFinish={requestOtp}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <div className="flex justify-between items-center w-full">
            <span className="text-lightGrey text-sm font-poppins font-normal break-words">
              {otpMedium === "email" ? "Email" : "Phone number"}:
            </span>
          </div>

          <Form.Item
            name="email"
            rules={[
              { required: true, message: "Please input your email!" },
              { type: 'email', message: 'Please enter a valid email!' }
            ]}
          >
            <Input
              type="email"
              className="md:min-h-[55px] max-h-[29px] text-xl text-lightGrey rounded-lg border border-inputBorder"
              placeholder="Enter your email"
            />
          </Form.Item>

          <Form.Item className="mt-5 flex justify-center">
            <button
              type="submit"
              className="md:min-w-[415px] md:min-h-[55px] min-w-[220.92px] min-h-[29.62px] rounded-md bg-yellow hover:bg-darkyellow"
              disabled={loading}
            >
              <span className="text-white text-base font-poppins font-bold break-words">
                {loading ? "Sending..." : "Submit"}
              </span>
            </button>
          </Form.Item>
        </Form>
      ) : (
        <Form
          form={resetForm}
          name="resetPassword"
          onFinish={handleResetPassword}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <div className="flex justify-between items-center w-full">
            <span className="text-lightGrey text-sm font-poppins font-normal break-words">
              New Password:
            </span>
          </div>

          <Form.Item
            name="password"
            rules={[
              { required: true, message: "Please input your new password!" },
              { min: 6, message: "Password must be at least 6 characters!" }
            ]}
          >
            <Input.Password
              className="md:min-h-[55px] max-h-[29px] text-xl text-lightGrey rounded-lg border border-inputBorder"
              placeholder="Enter new password"
            />
          </Form.Item>

          <div className="flex justify-between items-center w-full">
            <span className="text-lightGrey text-sm font-poppins font-normal break-words">
              Confirm Password:
            </span>
          </div>

          <Form.Item
            name="confirmPassword"
            dependencies={['password']}
            rules={[
              { required: true, message: "Please confirm your password!" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('The two passwords do not match!'));
                },
              }),
            ]}
          >
            <Input.Password
              className="md:min-h-[55px] max-h-[29px] text-xl text-lightGrey rounded-lg border border-inputBorder"
              placeholder="Confirm new password"
            />
          </Form.Item>

          <Form.Item className="mt-5 flex justify-center">
            <button
              type="submit"
              className="md:min-w-[415px] md:min-h-[55px] min-w-[220.92px] min-h-[29.62px] rounded-md bg-yellow hover:bg-darkyellow"
              disabled={loading}
            >
              <span className="text-white text-base font-poppins font-bold break-words">
                {loading ? "Resetting..." : "Reset Password"}
              </span>
            </button>
          </Form.Item>
        </Form>
      )}

      <Modal
        title="Enter PIN"
        open={isModalOpen}
        onCancel={handleCancel}
        className="max-w-[360px]"
        footer={null}
      >
        <div className="flex mt-4 flex-col gap-2 items-start">
          <p>Enter the 6-digit PIN sent to your email:</p>
          <span className="self-center">
            <OTPInput length={6} onChangeOTP={(value) => setOtp(value)} />
          </span>
          <div className="w-full flex justify-center mt-4">
            <button
              className="w-auto px-[4rem] py-4 rounded-md bg-radio"
              onClick={handleVerifyOtp}
              disabled={loading || otp.length !== 6}
            >
              <span className="text-white text-base font-poppins font break-words">
                {loading ? "Verifying..." : "Verify"}
              </span>
            </button>
          </div>
        </div>
      </Modal>
    </LoginDashBoard>
  );
}
